import {StoreItemCategory} from '../../../../shared/entity_datas/StoreEnums'
import {BaseStoreItem} from '../../../../shared/store/BaseStoreItem'
import {ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct'
import {UIMembershipProductView} from './UIMembershipProductView'
import {UIStoreMembershipTabsController} from './UIStoreMembershipTabsController'
import {GiftedMembershipItem} from '../../../../shared/store/UserItems'
import {PaymentMethod} from '../../../../shared/store/BaseColonistStoreProduct'
import {UIStoreGiftOverlayController} from './gift/UIStoreGiftOverlayController'
import {setElementInnerHTML} from '../ui_utils/DomUtils'

export abstract class UIStoreBodyController {
    readonly membershipItems: UIMembershipProductView[] = []
    giftOverlayController: UIStoreGiftOverlayController
    abstract readonly membershipTabsController: UIStoreMembershipTabsController

    constructor() {
        setTimeout(() => {
            const membershipTitle = document.getElementById('store_page_membership_title')
            if(membershipTitle == undefined) return
            setElementInnerHTML(membershipTitle, {key: 'strings:storePage.sections.membership.title'})
        }, 100)
    }

    abstract updateCategoryItems(category: StoreItemCategory, container: HTMLDivElement)
    abstract updateOwnedItems(ownedItems: BaseStoreItem[])
    abstract updateSubscribedItems(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined)
    abstract updateOwnedMembership(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined)
    abstract updatePriceForFounderPack(ownedItems: BaseStoreItem[])
    abstract updateGiftedMemberships(memberships: GiftedMembershipItem[])

    // eslint-disable-next-line class-methods-use-this
    protected shouldDisableMembershipManagement(paymentMethod: PaymentMethod | undefined): boolean {
        const isStripe = paymentMethod == PaymentMethod.Stripe
        const isIAP = paymentMethod == PaymentMethod.Apple || paymentMethod == PaymentMethod.Android
        const disableMembershipManagement = !isStripe && !isIAP
        return disableMembershipManagement
    }
}
